function capitalize(string) {
  if (!string) return ''
 return string.charAt(0).toUpperCase() + string.slice(1);
}  
  
const stripHtml = (html) => {
  let tmp = document.createElement("DIV");
  tmp.innerHTML = html;
  return tmp.textContent || tmp.innerText || "";
}

const truncateHtml = (markup, length = 200) => {
  const text = stripHtml(markup)
  const words = text.split(/[ \t\r\n]+/).map(word => word.trim())

  let output = ''
  for (let i = 0; i < words.length; i++) {
    if (output.length < length) {
      if (output.length + words[i].length < length) {
        output += `${words[i]} `
      }
    }
  }

  const trimmedOutput = output.trim()

  if (trimmedOutput) {
    return trimmedOutput.concat('&hellip;')
  }
  return ''
}

const cleanUrl = (url) => {
  if (url.indexOf('http') !== -1) {
    return url
  }
  return `https://${url}`
}

const formatCurrency = (amount) => {
  return Number(parseFloat(amount).toFixed(2)).toLocaleString('en', {
    minimumFractionDigits: 2
  });
}

const desnake = (str) => {
  if (!str) return ''
  return str.replace(/_/g, ' ')
}

const cleanStatus = (rawStatus) => {
  return capitalize(desnake(rawStatus))
}

const camelize = (str) => {
  return str.replace(/(?:^\w|[A-Z]|\b\w)/g, function(word, index) {
    return index === 0 ? word.toLowerCase() : word.toUpperCase()
  }).replace(/\s+/g, '')
}

const formatYoutubeURL = (url) => {
  let url_ = url
  const substringToReplace = 'https://www.youtube.com/watch?v='
  // With the slash, so a short link doesn't become `embed//<id>`.
  const substringV2ToReplace = 'https://youtu.be/'
  const substringV3ToReplace = 'https://www.youtube.com/shorts/'
  const replacementSubstring = 'https://www.youtube.com/embed/'

  if (url_.includes('www.youtube.com') && url_.includes('youtu.be')) {
    url_ = url_.split('&')[0]
  }

  if(url_.includes(substringToReplace)) {
    return url_.replace(substringToReplace, replacementSubstring)
  }

  if(url_.includes(substringV2ToReplace)) {
    return url_.replace(substringV2ToReplace, replacementSubstring)
  }

  if(url_.includes(substringV3ToReplace)) {
    return url_.replace(substringV3ToReplace, replacementSubstring)
  }

  return replacementSubstring + url_
}

const getPlural = (word) => {
  // Check if the word already ends with 's'
  if (word.endsWith('s')) {
    return word; // Return the word as is
  } else {
    // Check if the word ends with 'x', 'z', 'ch', or 'sh'
    if (word.endsWith('x') || word.endsWith('z') || word.endsWith('ch') || word.endsWith('sh')) {
      return word + 'es'; // Add 'es' for plural
    } else {
      return word + 's'; // Add 's' for plural
    }
  }
}

// Lower case, accents and apostrophes dropped, one space between words: "What’s New" meets "whats new".
const normalizeText = (text) => String(text ?? '')
  .normalize('NFD')
  .replace(/[̀-ͯ]/g, '')
  .replace(/['’‘]/g, '')
  .toLowerCase()
  .replace(/\s+/g, ' ')
  .trim()

// The words of a search, normalised the same way; none for an empty query.
const searchTerms = (query) => normalizeText(query).split(' ').filter(Boolean)

const escapeHtmlText = (s) => s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')

// A custom description is typed into a plain textarea but stored, previewed and
// listed as HTML, where a bare newline collapses into a space. Each line becomes
// its own paragraph and an empty line an empty one (`<p><br></p>`), the shape the
// template editor produces, so the spacing the seller typed survives the save.
const descriptionTextToHtml = (text) => {
  if (!text || !String(text).trim()) return ''
  return String(text)
    .replace(/\r\n?/g, '\n')
    .split('\n')
    .map((line) => `<p>${line.trim() ? escapeHtmlText(line) : '<br>'}</p>`)
    .join('')
}

// The reverse, for seeding the textarea from a stored description. Unlike the
// grid's `description_plain_text` it keeps empty lines, so opening and accepting
// a description again doesn't squeeze its paragraphs together. A description
// with no tags at all is older plain text and is returned as it is.
const descriptionHtmlToText = (html) => {
  if (!html) return ''
  const source = String(html)
  if (!/<[a-z][^>]*>/i.test(source)) return source

  const marked = source
    .replace(/<(style|script)[\s\S]*?<\/\1>/gi, '')
    .replace(/<(p|div|h[1-6])[^>]*>\s*<br\s*\/?>\s*<\/\1>/gi, '\n')
    .replace(/<\/(li|p|div|h[1-6])>/gi, '\n')
    .replace(/<br\s*\/?>/gi, '\n')
    .replace(/<[^>]+>/g, '')

  const doc = new DOMParser().parseFromString(`<textarea>${marked}</textarea>`, 'text/html')
  return (doc.querySelector('textarea')?.value || '')
    .replace(/\u00a0/g, ' ')
    .split('\n')
    .map((line) => line.replace(/[ \t]+/g, ' ').trim())
    .join('\n')
    .trim()
}

export {
    capitalize,
    desnake,
    cleanStatus,
    stripHtml,
    truncateHtml,
    cleanUrl,
    formatCurrency,
    camelize,
    formatYoutubeURL,
    getPlural,
    normalizeText,
    searchTerms,
    descriptionTextToHtml,
    descriptionHtmlToText
}